import React, {useState} from 'react';

function AddModelForm({ onModelAdded }) {
    const [formData, setFormData] = useState({
        name: '',
        location: '',
        description: '',
        price: '',
        category: 'Fashion',
        whatsapp: '',
        photo: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({...prev, [name]: ''}));
        }
    };
    const handleSubmit= async (e) => {
        e.preventDefault();
        const newErrors ={};
        if (!formData.name.trim()){
            newErrors.name ='Name is required';
        }
        if (!formData.location.trim()) {
            newErrors.location = 'Location is required';
        }
        if (!formData.description.trim()) {
            newErrors.description = 'Description is required';
        }
        if (!formData.price.trim()) {
            newErrors.price = 'Price is required';
        }
        if (!formData.whatsapp.trim()) {
            newErrors.whatsapp = 'Whatsapp number is required';
        }
        if (Object.keys(newErrors).length > 0){
            setErrors(newErrors);
            return;
        }
        setIsSubmitting(true);
        setErrors({});
        try{
            const response= await fetch('http://localhost:3000/api/models', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });
            if (response.ok) {
                const newModel= await response.json();
                onModelAdded(newModel);
                setFormData({
                    name: '',
                    location: '',
                    description: '',
                    price: '',
                    category: 'Fashion',
                    whatsapp: ''
                });
            } else {
                const errorData = await response.json();
                setErrors({general:errorData.message || 'Error creating model'})
            } 
            } catch (error) {
                setErrors({general: 'Network error. Please try again.'});
        } finally {
            setIsSubmitting(false);
        }
    };
    return (
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-6 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                Add New Model
            </h2>
            {errors.general && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                    {errors.general}
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Name *
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500 ${errors.name ? 'border-red-500':'border-gray-300'}`}
                        placeholder="Enter model name"
                    />
                    {errors.name && (
                        <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                    )}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Location *
                    </label>
                    <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500 ${errors.location ? 'border-red-500':'border-gray-300'}`}
                        placeholder="Enter model name"
                    />
                    {errors.location && (
                        <p className="text-red-500 text-sm mt-1">{errors.location}</p>
                    )}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Description *
                    </label>
                    <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    rows="4"
                    className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500 ${errors.description ?  'border-red-500' : 'border-gray-300'}`}
                    placeholder="Describe your experience and specialties"
                    />
                    {errors.description && (
                        <p className="text-red-500 text-sm mt-1">{errors.description}</p>
                    )}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Price per hour *
                    </label>
                    <input 
                    type="text"
                    name="price"
                    value={formData.price}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500 ${errors.price ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="e.g., 75"
                />
                {errors.price && (
                    <p className="text-red-500 text-sm mt-1">{errors.price}</p>
                )}
                </div>
                {/* Campo photo url */}
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Photo URL (Optional)
                    </label>
                    <input
                        type="text"
                        name="photo"
                        value={formData.photo || ''}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                        placeholder="https://example.com/photo.jpg"
                    />
                    <p className="text-gray-500 text-xs mt-1">
                        Paste a direct image URL (will implement file upload later)
                    </p>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Category *
                    </label>
                    <select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg foucs:outline-none focus:border-blue-500"
                    >
                        <option value="Fashion">Fashion</option>
                        <option value="Fitness">Fitness</option>
                        <option value="Commercial">Commercial</option>
                        <option value="Editorial">Editorial</option>
                        <option value="Lifestyle">Lifestyle</option>
                    </select>
                </div>
                <div className="mb-6">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Whatsapp Number *
                    </label>
                    <input
                        type="text"
                        name="whatsapp"
                        value={formData.whatsapp}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border rounded-lg fous:outline-none focus:border-blue-500 ${errors.whatsapp ? 'border-red-500' : 'border-gray-300'}`}
                        placeholder="e.g., +57 300 123 4567"
                    />
                    {errors.whatsapp && (
                        <p className="text-red-500 text-sm mt-1">{errors.whatsapp}</p>
                    )}
                </div>
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full py-2 px-4 rounded-lg font-medium ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}
                    >
                        {isSubmitting? 'Adding Model...' : 'Add Model'}
                    </button>
            </form>
        </div>
    );
};

export default AddModelForm;